import CustomerGridContainer from "./CustomerGridContainer";
export default CustomerGridContainer;